// extracted by mini-css-extract-plugin
module.exports = {"BlankPixel":"_1w8r9KAG_e1_l-Q1uqeohC"};